module.exports = "query adviceTotalCount($interval:Interval,$filters:[Filter!]){adviceRequestsCount(interval:$interval,filters:$filters){total}}"